import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["checkbox"];

  connect() {
    this.syncVisual();
  }

  click(event) {
    if (!this.hasCheckboxTarget) return;

    if (event.target === this.checkboxTarget) {
      this.syncVisual();
      return;
    }

    event.preventDefault();
    this.checkboxTarget.checked = !this.checkboxTarget.checked;
    this.syncVisual();
  }

  syncVisual() {
    if (!this.hasCheckboxTarget) return;

    this.element.classList.toggle(
      "cred-role-pill--active",
      this.checkboxTarget.checked
    );
  }
}
